import Levels from './Levels';

// Viewport dimensions
const h = window.innerHeight;
const w = window.innerWidth;

// Maximum board dimensions
const maxHeight = 11;
const maxWidth = 8;

// Tile size, limited by width or height
let widthPadding = 15;
let heightPadding = 40;
let d1 = (h - heightPadding * 2) / maxHeight;
let d2 = (w - widthPadding * 2) / maxWidth;
let d = Math.min(d1, d2);

// Coefficient to scale with
let c = Math.min(0.90, d / 50);

const freeLevels = 18;

// Create constants
const Constants = {

    /*
    General
    */

    name: 'Word Surge',
    appVersion: false, /*typeof window.cordova !== 'undefined',*/
    coolmathVersion: true,
    startingHints: 15,

    // How long to wait before pulsing the hint button, in ms
    stuckDuration: 20000,

    // Facebook and Twitter share links
    facebookShareLink: 'https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fword-surge.com',
    twitterShareLink: 'https://twitter.com/share?url=https%3A%2F%2Fword-surge.com&text=Check%20out%20Word%20Surge%2C%20a%20theme-based%20puzzle%20game%20about%20forming%20words%20and%20clearing%20levels%21&hashtags=WordSurge',

    // iOS and Android store links
    iosDownloadLink: 'https://itunes.apple.com/us/app/word-surge/id1465428508?ls=1&mt=8',
    androidDownloadLink: 'https://play.google.com/store/apps/details?id=com.aidan.WordSurgeCompliant',

    // In-app purchase prices
    hintAmounts: [5, 15, 50],

    // Free levels and paid levels
    freeLevels: freeLevels,
    paidLevels: Levels.length - freeLevels,

    // Level to request rating after completion of
    requestRatingLevel: 15,

    /*
    Board
    */

    // Tile dimensions
    tileSize: 50 * c,

    // Colors
    outerColor: '#fff',
    innerColor: '#f7f7f7',
    transitionOuterColor: '#54a0ff',
    transitionInnerColor: '#2e86de',
    letterPrimaryColor: '#54a0ff',
    letterSecondaryColor: '#2e86de',
    letterShadowColor: 'rgba(0,0,0,0.15)',

    // Letter dimensions
    letterSize: 42 * c,
    letterPadding: 4 * c,
    letterBlurRadius: 6 * c,
    letterDepth: 4 * c,
    letterFontSize: 18 * c,

    // Border radii
    innerBorderRadius: 6 * c,
    outerBorderRadius: 6 * c,
    letterBorderRadius: 7 * c,

    // Level number size
    levelNumberSize: 150 * c,

    /*
    Menu
    */

    menuTileSize: 8,
    menuBorderRadius: 8,

    menuInnerColor: '#2f3640',
    menuOuterColor: '#fff',
    menuLockedColor: '#E6E7E8',

    menuInnerBorderRadius: 3,
    menuOuterBorderRadius: 3,

    menuLevelSize: 130,
}


export default Constants;
